
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class TessellatedHexagonsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
         const size = (120 + layerIndex * 40) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, size * 1.5);
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const drawHex = (x: number, y: number, r: number) => {
            ctx.beginPath();
            for (let i = 0; i < 6; i++) {
                const a = (i / 6) * Math.PI * 2;
                const px = x + Math.cos(a) * r;
                const py = y + Math.sin(a) * r;
                if (i === 0) ctx.moveTo(px, py);
                else ctx.lineTo(px, py);
            }
            ctx.closePath();
            ctx.stroke();
            
            // Sub-pattern
            ctx.save();
            ctx.globalAlpha *= 0.3;
            for (let i = 0; i < 6; i++) {
                const a = (i / 6) * Math.PI * 2;
                ctx.beginPath();
                ctx.moveTo(x, y);
                ctx.lineTo(x + Math.cos(a) * r, y + Math.sin(a) * r);
                ctx.stroke();
            }
            ctx.restore();
        };

        const draw = () => {
            const h = size * Math.sqrt(3);
            for (let x = x1; x <= x2; x += size * 1.5) {
                for (let y = y1; y <= y2; y += h) {
                    const offset = (Math.round(x / (size * 1.5)) % 2 === 0) ? 0 : h / 2;
                    drawHex(x, y + offset, size * 0.9 * scale);
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
